import{S as g}from"./addToCart-CRSCIkB-.js";const C=`
  query getProduct(
    $handle: String!
  ) {
    product(handle: $handle) {
      id
      title
      publishedAt
      updatedAt
      handle
      tags
      availableForSale
      totalInventory
      productType
      vendor
      compareAtPriceRange {
        maxVariantPrice {
          amount
          currencyCode
        }
        minVariantPrice {
          amount
          currencyCode
        }
      }
      collections(first: 250) {
        nodes {
          handle
          title
        }
      }
      metafields(
        identifiers: [
          { namespace: "custom", key: "size_guide_type" }
        ]
      ) {
        value
        id
        key
        value
      }
      options {
        id
        name
        values
      }
      priceRange {
        maxVariantPrice {
          amount
          currencyCode
        }
        minVariantPrice {
          amount
          currencyCode
        }
      }
      images(first: 100) {
        nodes {
          transformedSrc
        }
      }
      variants(first: 200) {
        nodes {
          id
          title
          sku
          quantityAvailable
          availableForSale
          selectedOptions {
            name
            value
          }
          image {
            url
            altText
            width
            height
          }
          price {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
            currencyCode
          }
        }
      }
    }
  }
`,b=`
query getProductsByTag($tag: String!) {
  products(first: 250, query: $tag) {
    nodes {
      id
      handle
      tags
      descriptionHtml
      productType
      title
      totalInventory
      vendor
      collections(first: 30) {
        nodes {
          handle
          title
        }
      }
      metafields(
        identifiers: [
          { namespace: "custom", key: "size_guide_type" }
        ]
      ) {
        value
        id
        key
        value
      }

      images(first: 10) {
        nodes {
          url
        }
      }
      media(first: 10) {
        nodes {
          mediaContentType
          previewImage {
            url
          }
        }
      }
      options {
        name
        values
      }
      compareAtPriceRange {
        maxVariantPrice{
          amount
          currencyCode
        }
        minVariantPrice {
          amount
          currencyCode
        }
      }
      priceRange {
        maxVariantPrice {
          amount
          currencyCode
        }
        minVariantPrice {
          amount
          currencyCode
        }
      }
      seo {
        description
        title
      }
      variants(first: 250) {
        nodes {
          availableForSale
          compareAtPrice {
            amount
            currencyCode
          }
          id
          price {
            amount
            currencyCode
          }
          quantityAvailable
          selectedOptions {
            name
            value
          }
          sku
          title
          unitPrice {
            amount
            currencyCode
          }
        }
      }
    }
  }
}

`,E=async e=>{var t,a;try{const r=await g(C,{handle:e});if((t=r==null?void 0:r.errors)!=null&&t.length)throw new Error(r.errors[0].message);return((a=r.data)==null?void 0:a.product)??null}catch(r){return console.error("Error fetching product:",r.message),null}},x=async e=>{var a;const t=async r=>{var o,i;const n=await g(b,{tag:r});if((o=n==null?void 0:n.errors)!=null&&o.length)throw new Error(n.errors[0].message);return((i=n.data)==null?void 0:i.products)??null};try{const r=await t(`available_for_sale:true AND tag:'${e}'`);return!((a=r==null?void 0:r.nodes)!=null&&a.length)||r.nodes[0]==null?await t(`tag:'${e}'`):r}catch(r){return console.error("Error fetching product:",r.message),null}},f="TED BAKER WISHLIST",w=()=>typeof window<"u",_=e=>{var a;if(!w()||!e.email)return;const t={$email:e.email};e.firstName&&(t.$first_name=e.firstName),e.lastName&&(t.$last_name=e.lastName);try{(a=window.klaviyo)!=null&&a.identify?window.klaviyo.identify(t):(window._learnq=window._learnq||[],window._learnq.push(["identify",t]))}catch(r){console.error("Klaviyo identify failed:",r.message)}},P=(e,t,a,r={})=>{var o;if(!w()||!t.email)return;const n={Action:e,Email:t.email,FirstName:t.firstName,LastName:t.lastName,ItemCount:a.length,Items:a,...r};try{(o=window.klaviyo)!=null&&o.track?window.klaviyo.track(f,n):(window._learnq=window._learnq||[],window._learnq.push(["track",f,n]))}catch(i){console.error("Klaviyo track failed:",i.message)}},v=e=>e?`${window.location.origin}/products/${e}`:window.location.href,p="ted-baker-south-africa.myshopify.com",A="https://zooomyapps.com/wishlist/api/frontend",S="ted-baker__wishlist",R=e=>!e||!e.id||e.id==="null"||e.id==="",L=()=>{try{const e=localStorage.getItem(S),t=e?JSON.parse(e):null;return Array.isArray(t)?t:[]}catch{return[]}},I=e=>{try{localStorage.setItem(S,JSON.stringify(e))}catch{}},k=e=>{if(typeof e!="string")return null;const t=e.match(/^gid:\/\/shopify\/Product\/(\d+)$/);return t?t[1]:null},O=e=>{if(typeof e!="string")return null;const t=e.match(/^gid:\/\/shopify\/ProductVariant\/(\d+)$/);return t?t[1]:null},q=e=>{const t=String(e).split("/");return t[t.length-1]},s=e=>{const t=document.getElementById("alert-banner");t&&(t.classList.remove("x-hidden"),t.classList.add("x-flex"),t.innerHTML=e,window.setTimeout(()=>{t.classList.add("x-hidden"),t.classList.remove("x-flex")},3e3))},h=async(e,t,a="")=>{try{const r=await fetch(`${A}/${e}${a}`,{method:"POST",body:new URLSearchParams(t)});return r.ok?await r.json():(console.error(`Zooomy ${e} failed: HTTP ${r.status}`),null)}catch(r){return console.error(`Zooomy ${e} unreachable:`,r.message),null}},$=e=>{try{return btoa(e||"")}catch{return""}},T=e=>({email:e.email,firstName:e.firstName??"",lastName:e.lastName??""}),V=async e=>{const t=await h("wishlist",{shop:p,customerid:e.id,lang:"en"});if(!t)return null;if(t.plan==="free")return console.error("Zooomy wishlist is on the free plan — the API will not return data."),null;const r=(t.product_id??[]).map((n,o)=>{var i,c,d,l,u;return{product_id:n??"",product_handle:((i=t.product_handle)==null?void 0:i[o])??"",proimage:((c=t.product_img)==null?void 0:c[o])??"",protitle:((d=t.product_name)==null?void 0:d[o])??"",vname:((l=t.variant_name)==null?void 0:l[o])??"",proprice:((u=t.product_price)==null?void 0:u[o])??"",checked:!0}});return I(r),{entries:r,records:t.count??r.length}},W=async(e,t)=>{var i,c,d,l,u,m;const a=(c=(i=e.images)==null?void 0:i.nodes)==null?void 0:c[0],r=(l=(d=e.variants)==null?void 0:d.nodes)==null?void 0:l[0],n={product_id:k(e.id)??"",product_handle:e.handle??"",proimage:(a==null?void 0:a.url)||(a==null?void 0:a.transformedSrc)||"",protitle:e.title,vname:(r==null?void 0:r.title)??"",proprice:((m=(u=e.priceRange)==null?void 0:u.maxVariantPrice)==null?void 0:m.amount)??"",variant_id:r==null?void 0:r.id,checked:!0},o=await h("collecion-check",{shop:p,productid:n.product_id,customerid:t.id,title:n.protitle,handle:n.product_handle,img:n.proimage,price:n.proprice,cval:$(t.email),customer_name:t.name});if((o==null?void 0:o.done)!=="done")return s("Product could not be added to wishlist. Please try again later!"),null;s("Product has been successfully added to wishlist!");try{const y=T(t);_(y),P("Added",y,[{ProductID:n.product_id,ProductName:n.protitle,ProductURL:v(n.product_handle),ImageURL:n.proimage,Price:n.proprice,Handle:n.product_handle,VariantID:n.variant_id}],{Source:"wishlist-heart"})}catch{}return n},U=async(e,t,a)=>{const r=await h("remove-product",{shop:p,productid:e,customerid:t.id});if((r==null?void 0:r.done)!=="done")return s("Product could not be removed from wishlist. Please try again later!"),!1;s("Product has been successfully removed from wishlist!");try{const n=T(t);_(n),P("Removed",n,[{ProductID:e,ProductName:(a==null?void 0:a.title)??e,ProductURL:v((a==null?void 0:a.handle)??""),ImageURL:(a==null?void 0:a.image)??"",Price:(a==null?void 0:a.price)??"",Handle:(a==null?void 0:a.handle)??""}],{Source:"wishlist-heart"})}catch{}return!0},D=async(e,t,a=1)=>{try{const n=await(await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({form_type:"product",utf8:"✓",id:t,"section-id":"shopify-section-template--23890497601817__main","product-id":k(e.id),sections_url:`/products/${e.handle}`,sections:"sections--23890496520473__header,sections--23890496684313__cart-drawer",quantity:a})})).json();return(n==null?void 0:n.status)===422?(s("Product already in your cart!"),!1):(s("Product has been successfully added to your cart!"),!0)}catch(r){return console.error("Error adding product to cart:",r),!1}};export{W as a,x as b,O as c,D as d,q as e,V as f,E as g,L as h,R as i,P as j,_ as k,k as l,U as r,v as t,I as w};
